export const CHANGE_LOCALE = 'CHANGE_LOCALE';
export const DEFAULT_LOCALE = 'fr';
export const ARABIC_LOCAL = 'ar';
